module.exports = __webpack_public_path__ + "static/media/premium-failure.fda2476d.svg";